import { getSourceMode } from "shared/components/SourceEditor";
import { MAPPING_TYPES, SKIP_ANCHOR_TYPES, SOURCE_MODES } from "./constants";

export const isCheckboxAnchor = (anchor) =>
  /^\[[A-Z][A-Za-z0-9]*\]$/.test(anchor);

export const getCheckboxBase = (anchor) => {
  const m = anchor.match(/^\[([A-Z]+)/);
  return m ? m[1] : null;
};

const CHILD_INDEXED_RE = /^([A-Za-z]+)\.(\d+)\.(.+)$/;
const CHILD_LOOP_KEY_RE = /^([A-Za-z]+)\.N\.(.+)$/;

export const getChildLoopGroupKey = (anchor) => {
  const m = anchor.match(CHILD_INDEXED_RE);
  return m ? `${m[1]}.N.${m[3]}` : null;
};

export const getChildLoopIndex = (anchor) => {
  const m = anchor.match(CHILD_INDEXED_RE);
  return m ? Number.parseInt(m[2], 10) : null;
};

export const isChildLoopKey = (key) => CHILD_LOOP_KEY_RE.test(key);

export const isSkipAnchor = (anchor) =>
  anchor
    .split("|")
    .slice(1)
    .some((part) => SKIP_ANCHOR_TYPES.has(part));

export const mappingKeyFor = (anchor) => getChildLoopGroupKey(anchor) || anchor;

export const isDentalMapping = (mapping) =>
  mapping?.type === MAPPING_TYPES.DENTAL;

export const isStaticMapping = (mapping) =>
  mapping?.type === MAPPING_TYPES.STATIC;

export const hasSource = (mapping = {}) => {
  const mode = getSourceMode(mapping);
  if (mode === SOURCE_MODES.KEYS)
    return (mapping.keys || []).some((key) => !!key);
  if (mode === SOURCE_MODES.FROM) return !!mapping.from?.path;
  if (mode === SOURCE_MODES.STATIC) return true;
  if (mode === SOURCE_MODES.COMBINE)
    return (mapping.combine?.parts || []).some(hasSource);
  return !!mapping.key;
};
